import React from 'react';
import { motion } from 'framer-motion';

export function ProgressBar({ currentStep, totalSteps }) {
  if (currentStep === 0 || currentStep === totalSteps - 1) return null;
  const progress = (currentStep / (totalSteps - 1)) * 100;

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="h-1 bg-dark-card w-full">
        <motion.div 
          className="h-full bg-brand-blue"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.4 }}
        />
      </div>
      <div className="text-center mt-0.5">
        <span className="text-[9px] font-black text-gray-700 uppercase tracking-[0.2em]">
           Progress: {Math.round(progress)}%
        </span>
      </div>
    </div>
  );
}